import React, { useEffect, useState } from "react";
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function Successlog() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true); // To check if there are more items to load
    const [total, setTotal] = useState(0);
    const [payloadData, setPayloadData] = useState('');
    const [openPayloadDialog, setOpenPayloadDialog] = useState(false);

    const fetchData = async (currentPage) => {
        try {
            const response = await axios.get('https://sf-lms-sync-dev-api.ken42.com/successlogs', { 
                params: { 
                    page: currentPage, 
                    limit: 10,  // Number of items per page
                    type: 'success' 
                } 
            });

            const { data: fetchedData, total: totalCount } = response.data;

            // Check if more data is available
            if (fetchedData.length === 0 || fetchedData.length < 10) {
                setHasMore(false);
            }

            // Transform and update data
            const transformedData = fetchedData.map((log) => ({
                id: log.id,  // Use the id from the backend
                ORG_ID: log.orgId || 'N/A',
                Event_TYPE: log.eventType || 'N/A',
                Event_ID: log.eventId || 'N/A',
                PAYLOAD: log.message || 'N/A',
                TIMESTAMP: log.timestamp || 'N/A',
                MOODLERESPONSE:log?.moodleResponse ? JSON.stringify(log.moodleResponse) : 'N/A' 
            }));

            setData(prevData => [...prevData, ...transformedData]);  // Append new data
            setTotal(totalCount);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(page);
    }, [page]);  // Fetch data whenever the page changes

    const loadMoreData = () => {
        if (hasMore) {
            setPage(prevPage => prevPage + 1);
        }
    };

    const handleErrorlogs = async () => {
        navigate("/Errorlog");
    }
    const handlePayloadClick = (payload) => {
        setPayloadData(payload);
        setOpenPayloadDialog(true);
      };
    

    if (loading && page === 1) return <p align="center">Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const columns = [
        { field: 'ORG_ID', headerName: 'ORG_ID', width: 130 },
        { field: 'Event_TYPE', headerName: 'Event_TYPE', width: 150 },
        { field: 'Event_ID', headerName: 'Event_ID', width: 150 },
        { field: 'PAYLOAD', headerName: 'PAYLOAD', width: 750,
            renderCell: (params) => (
              <span style={{ cursor: 'pointer'}} onClick={() => handlePayloadClick(params.row.PAYLOAD)}>
                {params.value}
              </span>
            )
          },
        { field: 'TIMESTAMP', headerName: 'TIMESTAMP', width: 200 },
        {field:'MOODLERESPONSE',headerName:'MOODLERESPONSE',width:300, 
            renderCell: (params) => (
                <span style={{ cursor: 'pointer'}} onClick={() => handlePayloadClick(params.row.MOODLERESPONSE)}>
                  {params.value}
                </span>
              )
        }
    ];

    return (
        <div>
            <div className="row">
                <div className="row">
                    <div className="d-flex align-items-center">
                        <h1 align="center" style={{ position: "sticky", backgroundColor: "black", color: "white", width: "100%", height: "80px", borderRadius: "8px" }}>
                            MESSAGE LOGS
                        </h1>
                    </div>
                </div>
               
                <div className="row" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" color="success">
                            Success
                        </Button>
                        <Button variant="outlined" color="error" onClick={handleErrorlogs}>
                            Error
                        </Button>
                    </Stack>
                </div>
                <div class="row " style={{display: 'flex', justifyContent: 'flex-end' }}>
                <h3>Total count: {total}</h3>
                </div>
                <div className="row">
                    <div style={{ height: 600, width: '100%', padding: "20px" }}>
                        <DataGrid
                            rows={data}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[5, 10]}
                            checkboxSelection
                        />
                        <Dialog
              open={openPayloadDialog}
              onClose={() => setOpenPayloadDialog(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description" 
            >
              <DialogTitle id="alert-dialog-title">{"Payload Details"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {payloadData}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenPayloadDialog(false)}>Close</Button>
              </DialogActions>
            </Dialog>
                    </div>
                    {hasMore && (
                        <div className="row">
                            <Button variant="contained" size="medium" onClick={loadMoreData}>
                                Load More
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}














// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { DataGrid } from "@mui/x-data-grid";
// import Stack from "@mui/material/Stack";
// import Button from "@mui/material/Button";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import { useNavigate } from "react-router-dom";

// export default function Successlog() {
//   const navigate = useNavigate();
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [open, setOpen] = React.useState(false);
//   const [selectedRows, setSelectedRows] = useState([]);
  
//   // Define fetchData as a separate function
//   const fetchData = async () => {
//     try {
//       const response = await axios.get("http://localhost:4000/successlogs", {
//         params: { type: "success" },
//       });
//       const transformedData = response.data.map((log, index) => ({
//         id: log.id,  // Use MongoDB _id as id for DataGrid
//         ORG_ID: log.orgId || "N/A",
//         Event_TYPE: log.eventType || "N/A",
//         Event_ID: log.eventId || "N/A",
//         PAYLOAD: log.message || "N/A",
//         TIMESTAMP: log.timestamp || "N/A",
//       }));
//       const reversedData = transformedData.reverse();

//       // Update the state with the reversed data
//       setData(reversedData);
//     } catch (err) {
//       setError(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData(); // Call fetchData in useEffect
//   }, []);

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleRetrigger = async () => {
//     try {
//       // Extract IDs of selected rows
//       const selectedIds = selectedRows.map(row => row.id);

//       // Send retrigger request for selected rows
//       await axios.post("http://localhost:4000/retrigger", { ids: selectedIds });
//       await fetchData(); // Refresh data after retrigger
//     } catch (err) {
//       setError(err);
//     } finally {
//       handleClose();
//     }
//   };

//   const handleErrorlog = () => {
//     navigate("/Errorlog");
//   };

//   const handleRowSelection = (selectedIds) => {
//     // Convert selected IDs to objects matching row data
//     const selectedRowsData = data.filter(row => selectedIds.includes(row.id));
//     setSelectedRows(selectedRowsData);
//   };

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error.message}</p>;

//   const columns = [
//     { field: "ORG_ID", headerName: "ORG_ID", width: 130 },
//     { field: "Event_TYPE", headerName: "Event_TYPE", width: 150 },
//     { field: "Event_ID", headerName: "Event_ID", width: 150 },
//     { field: "PAYLOAD", headerName: "PAYLOAD", width: 900 },
//     { field: "TIMESTAMP", headerName: "TIMESTAMP", width: 180 },
//   ];

//   return (
//     <div style={{ height: 650, width: "100%" }}>
//       <h1>Success Log</h1>
//       <DataGrid
//         rows={data}
//         columns={columns}
//         pageSize={5}
//         rowsPerPageOptions={[5, 10]}
//         checkboxSelection
//         onSelectionModelChange={(newSelection) => {
//           handleRowSelection(newSelection); // Update selected rows on change
//         }}
//       />
//       <Stack direction="row" spacing={2} style={{ marginTop: 16 }}>
//         <Button variant="contained" onClick={handleErrorlog}>
//           Go to Error Log
//         </Button>
//         <Button variant="contained" color="error" onClick={handleClickOpen}>
//           Retrigger Selected
//         </Button>
//         <Dialog
//           open={open}
//           onClose={handleClose}
//           aria-labelledby="alert-dialog-title"
//           aria-describedby="alert-dialog-description"
//         >
//           <DialogTitle id="alert-dialog-title">{"Retrigger Confirmation"}</DialogTitle>
//           <DialogContent>
//             <DialogContentText id="alert-dialog-description">
//               Are you sure you want to retrigger the selected data?
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleClose}>Cancel</Button>
//             <Button onClick={handleRetrigger} autoFocus>
//               Confirm
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Stack>
//     </div>
//   );
// }
